import { request } from "../utils/api";

const buildQuery = (params = {}) => {
  const entries = Object.entries(params).filter(
    ([, v]) => v !== undefined && v !== null && v !== "",
  );
  if (!entries.length) return "";
  return `?${new URLSearchParams(entries).toString()}`;
};

/** Search RxNorm / custom medication catalog. */
export const searchRxnormMedications = (params) =>
  request(`/medications/rxnorm/search${buildQuery(params)}`);

/** Create a new medication catalog row (all fields required). */
export const createRxnormMedication = (data) =>
  request(`/medications/rxnorm`, {
    method: "POST",
    body: JSON.stringify(data),
  });
